function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52 52"
}, props), React.createElement("path", {
  d: "M50.5 50.558a4.5 4.5 0 01-6.363-.008L32.307 38.7c-3.27 2.086-7.132 3.332-11.299 3.327C9.41 42.012.02 32.598.035 21 .05 9.402 9.465.012 21.062.027 32.66.042 42.05 9.457 42.035 21.054c-.005 4.167-1.261 8.027-3.356 11.29l11.83 11.85a4.497 4.497 0 01-.009 6.364zM21.055 6.028c-8.283-.012-15.009 6.694-15.02 14.98-.01 8.286 6.698 15.008 14.981 15.019 8.286.01 15.009-6.695 15.02-14.98.01-8.287-6.695-15.01-14.981-15.02z",
  fill: "#000"
})));